import { createContext as t, useContext as r } from "react";
const o = t({
  isSearchBarDropdownOpen: !1,
  isInputOpen: !1,
  defaultValue: "",
  commands: () => {
  }
}), a = () => {
  const e = r(o);
  if (!e)
    throw new Error("Searchbar.* must be used within SearchBar.Root component");
  return e;
};
export {
  o as SearchBarContext,
  a as useSearchBarContext
};
